export enum NewsContentType {
  TextNews = "خبر متنی",
  PhotoNews = "خبر تصویری",
  VideoNews = "خبر ویدیویی",
}
